export default "__VITE_ASSET__boDNPt_s__"